import { useMemo as r, createElement as e, Fragment as o } from "react";
import { useTheme as t, usePropertyAccessor as n, useValueFormatter as i, Container as a, useDimensions as l, bindDefs as d, SvgWrapper as c, ResponsiveWrapper as s } from "@nivo/core";
import { useArcGenerator as u, ArcsLayer as v, ArcLabelsLayer as f } from "@nivo/arcs";
import { BasicTooltip as h, useTooltip as m } from "@nivo/tooltip";
import { jsx as p } from "react/jsx-runtime";
import { hierarchy as b, partition as C } from "d3-hierarchy";
import g from "lodash/cloneDeep";
import M from "lodash/sortBy";
import { useOrdinalColorScale as L, useInheritedColor as y } from "@nivo/colors";
function R() {
  return R = Object.assign || function (r) {
    for (var e = 1; e < arguments.length; e++) {
      var o = arguments[e];
      for (var t in o) Object.prototype.hasOwnProperty.call(o, t) && (r[t] = o[t]);
    }
    return r;
  }, R.apply(this, arguments);
}
var x = {
    id: "id",
    value: "value",
    cornerRadius: 0,
    layers: ["arcs", "arcLabels"],
    colors: {
      scheme: "nivo"
    },
    colorBy: "id",
    inheritColorFromParent: !0,
    childColor: {
      from: "color"
    },
    borderWidth: 1,
    borderColor: "white",
    enableArcLabels: !1,
    arcLabel: "formattedValue",
    arcLabelsRadiusOffset: .5,
    arcLabelsSkipAngle: 0,
    arcLabelsTextColor: {
      theme: "labels.text.fill"
    },
    animate: !0,
    motionConfig: "gentle",
    transitionMode: "innerRadius",
    isInteractive: !0,
    defs: [],
    fill: [],
    tooltip: function tooltip(r) {
      var e = r.id,
        o = r.formattedValue,
        t = r.color;
      return p(h, {
        id: e,
        value: o,
        enableChip: !0,
        color: t
      });
    },
    role: "img"
  },
  F = function F(e) {
    var o = e.data,
      a = e.id,
      l = void 0 === a ? x.id : a,
      d = e.value,
      c = void 0 === d ? x.value : d,
      s = e.valueFormat,
      v = e.radius,
      f = e.cornerRadius,
      h = void 0 === f ? x.cornerRadius : f,
      m = e.colors,
      p = void 0 === m ? x.colors : m,
      R = e.colorBy,
      F = void 0 === R ? x.colorBy : R,
      I = e.inheritColorFromParent,
      W = void 0 === I ? x.inheritColorFromParent : I,
      k = e.childColor,
      A = void 0 === k ? x.childColor : k,
      O = t(),
      G = L(p, F),
      P = y(A, O),
      w = n(l),
      B = n(c),
      E = i(s),
      T = r(function () {
        var r,
          e = g(o),
          t = b(e).sum(B),
          n = C().size([2 * Math.PI, v * v])(t).descendants().slice(1),
          i = null != (r = t.value) ? r : 0;
        return M(n, "depth").reduce(function (r, e) {
          var o,
            t = w(e.data),
            n = e.value,
            a = 100 * n / i,
            l = e.ancestors().map(function (r) {
              return w(r.data);
            }),
            d = {
              startAngle: e.x0,
              endAngle: e.x1,
              innerRadius: Math.sqrt(e.y0),
              outerRadius: Math.sqrt(e.y1)
            };
          e.parent && (o = r.find(function (r) {
            return r.id === w(e.parent.data);
          }));
          var c = {
            id: t,
            path: l,
            value: n,
            percentage: a,
            formattedValue: s ? E(n) : a.toFixed(2) + "%",
            color: "",
            arc: d,
            data: e.data,
            depth: e.depth,
            height: e.height
          };
          return W && o && c.depth > 1 ? c.color = P(o, c) : c.color = G(c), [].concat(r, [c]);
        }, []);
      }, [o, v, B, w, s, E, G, W, P]);
    return {
      arcGenerator: u({
        cornerRadius: h
      }),
      nodes: T
    };
  },
  I = function I(e) {
    var o = e.nodes,
      t = e.arcGenerator,
      n = e.centerX,
      i = e.centerY,
      a = e.radius;
    return r(function () {
      return {
        nodes: o,
        arcGenerator: t,
        centerX: n,
        centerY: i,
        radius: a
      };
    }, [o, t, n, i, a]);
  },
  W = function W(o) {
    var t = o.center,
      n = o.data,
      i = o.arcGenerator,
      a = o.borderWidth,
      l = o.borderColor,
      d = o.isInteractive,
      c = o.onClick,
      s = o.onMouseEnter,
      u = o.onMouseMove,
      f = o.onMouseLeave,
      h = o.tooltip,
      b = o.transitionMode,
      C = m(),
      g = C.showTooltipFromEvent,
      M = C.hideTooltip,
      L = r(function () {
        if (d) return function (r, e) {
          null == c || c(r, e);
        };
      }, [d, c]),
      y = r(function () {
        if (d) return function (r, o) {
          g(e(h, r), o), null == s || s(r, o);
        };
      }, [d, g, h, s]),
      R = r(function () {
        if (d) return function (r, o) {
          g(e(h, r), o), null == u || u(r, o);
        };
      }, [d, g, h, u]),
      x = r(function () {
        if (d) return function (r, e) {
          M(), null == f || f(r, e);
        };
      }, [d, M, f]);
    return p(v, {
      center: t,
      data: n,
      arcGenerator: i,
      borderWidth: a,
      borderColor: l,
      transitionMode: b,
      onClick: L,
      onMouseEnter: y,
      onMouseMove: R,
      onMouseLeave: x
    });
  },
  k = ["isInteractive", "animate", "motionConfig", "theme", "renderWrapper"],
  A = function A(t) {
    var n = t.data,
      i = t.id,
      a = void 0 === i ? x.id : i,
      s = t.value,
      u = void 0 === s ? x.value : s,
      v = t.valueFormat,
      h = t.cornerRadius,
      m = void 0 === h ? x.cornerRadius : h,
      b = t.layers,
      C = void 0 === b ? x.layers : b,
      g = t.colors,
      M = void 0 === g ? x.colors : g,
      L = t.colorBy,
      y = void 0 === L ? x.colorBy : L,
      R = t.inheritColorFromParent,
      k = void 0 === R ? x.inheritColorFromParent : R,
      A = t.childColor,
      O = void 0 === A ? x.childColor : A,
      G = t.borderWidth,
      P = void 0 === G ? x.borderWidth : G,
      w = t.borderColor,
      B = void 0 === w ? x.borderColor : w,
      E = t.margin,
      T = t.width,
      X = t.height,
      Y = t.enableArcLabels,
      j = void 0 === Y ? x.enableArcLabels : Y,
      K = t.arcLabel,
      S = void 0 === K ? x.arcLabel : K,
      V = t.arcLabelsRadiusOffset,
      q = void 0 === V ? x.arcLabelsRadiusOffset : V,
      H = t.arcLabelsSkipAngle,
      z = void 0 === H ? x.arcLabelsSkipAngle : H,
      D = t.arcLabelsTextColor,
      J = void 0 === D ? x.arcLabelsTextColor : D,
      N = t.arcLabelsComponent,
      Q = t.defs,
      U = void 0 === Q ? x.defs : Q,
      Z = t.fill,
      $ = void 0 === Z ? x.fill : Z,
      _ = t.transitionMode,
      rr = void 0 === _ ? x.transitionMode : _,
      er = t.isInteractive,
      or = void 0 === er ? x.isInteractive : er,
      tr = t.onClick,
      nr = t.onMouseEnter,
      ir = t.onMouseLeave,
      ar = t.onMouseMove,
      lr = t.tooltip,
      dr = void 0 === lr ? x.tooltip : lr,
      cr = t.role,
      sr = void 0 === cr ? x.role : cr,
      ur = l(T, X, E),
      vr = ur.innerHeight,
      fr = ur.innerWidth,
      hr = ur.margin,
      mr = ur.outerHeight,
      pr = ur.outerWidth,
      br = r(function () {
        return {
          radius: Math.min(fr, vr) / 2,
          centerX: fr / 2,
          centerY: vr / 2
        };
      }, [vr, fr]),
      Cr = br.centerX,
      gr = br.centerY,
      Mr = br.radius,
      Lr = F({
        data: n,
        id: a,
        value: u,
        valueFormat: v,
        radius: Mr,
        cornerRadius: m,
        colors: M,
        colorBy: y,
        inheritColorFromParent: k,
        childColor: O
      }),
      yr = Lr.arcGenerator,
      Rr = Lr.nodes,
      xr = d(U, Rr, $, {
        dataKey: ".",
        colorKey: "color",
        targetKey: "fill"
      }),
      Fr = {
        arcs: null,
        arcLabels: null
      };
    C.includes("arcs") && (Fr.arcs = p(W, {
      center: [Cr, gr],
      data: Rr,
      arcGenerator: yr,
      borderWidth: P,
      borderColor: B,
      transitionMode: rr,
      isInteractive: or,
      tooltip: dr,
      onClick: tr,
      onMouseEnter: nr,
      onMouseLeave: ir,
      onMouseMove: ar
    }, "arcs")), j && C.includes("arcLabels") && (Fr.arcLabels = p(f, {
      center: [Cr, gr],
      data: Rr,
      label: S,
      radiusOffset: q,
      skipAngle: z,
      textColor: J,
      transitionMode: rr,
      component: N
    }, "arcLabels"));
    var Ir = I({
      nodes: Rr,
      arcGenerator: yr,
      centerX: Cr,
      centerY: gr,
      radius: Mr
    });
    return p(c, {
      width: pr,
      height: mr,
      defs: xr,
      margin: hr,
      role: sr,
      children: C.map(function (r, t) {
        return void 0 !== Fr[r] ? Fr[r] : "function" == typeof r ? p(o, {
          children: e(r, Ir)
        }, t) : null;
      })
    });
  },
  O = function O(r) {
    var e = r.isInteractive,
      o = void 0 === e ? x.isInteractive : e,
      t = r.animate,
      n = void 0 === t ? x.animate : t,
      i = r.motionConfig,
      l = void 0 === i ? x.motionConfig : i,
      d = r.theme,
      c = r.renderWrapper,
      s = function (r, e) {
        if (null == r) return {};
        var o,
          t,
          n = {},
          i = Object.keys(r);
        for (t = 0; t < i.length; t++) o = i[t], e.indexOf(o) >= 0 || (n[o] = r[o]);
        return n;
      }(r, k);
    return p(a, {
      isInteractive: o,
      animate: n,
      motionConfig: l,
      theme: d,
      renderWrapper: c,
      children: p(A, R({
        isInteractive: o
      }, s))
    });
  },
  G = function G(r) {
    return p(s, {
      children: function children(e) {
        var o = e.width,
          t = e.height;
        return p(O, R({
          width: o,
          height: t
        }, r));
      }
    });
  };
export { G as ResponsiveSunburst, O as Sunburst, x as defaultProps, F as useSunburst, I as useSunburstLayerContext };